<template>
	<div class="variant-editor" :class="{'not-highlighted' : !higlightOrEditing, 'editorIsDisabled': editorIsDisabled}">
	<span ref="variantEditor"></span>
		<context-menu  
			v-if="contextMenu && 
			!$store.state.showingTemplateBackupInPreview" 
			:left="contextMenu.x" 
			:top="contextMenu.y" 
			topArrow 
			@close="contextMenu = null"
		>
			<a class="menu-item var" @click="onAddVariable">{{$t('variant-editor.add-variable')}}</a>
			<!-- <a v-if="globalSynonyms.length == 0" class="menu-item syn" @click="onAddSynonym(false)">+ Synonym</a> -->
				
			<div 
				ref="globalSynonymsSubmenu" 
				class="menu-item submenu global-synonym" 
				@mouseover="customGlobalSynsContextMenu = true" 
				@mouseleave="customGlobalSynsContextMenu = false"
			>
				<span class="template-synonym-menu syn">
					Synonym
				</span> 
				<div  v-if="customGlobalSynsContextMenu" class="custom-scrollbar-grey-on-grey"  :class="contextMenu.y < 690 ? 'custom-context-menu-descending' : 'custom-context-menu' ">	
					<a class="menu-item syn " @click="onAddSynonym(false)">
						+ Synonym
					</a>
					<a @click="onAddSynonym(true)" class="menu-item ai-syn" v-if="selectionLength > 0" :class="{'global-synonym-seperator' : globalSynonyms.length > 0}">
						<span>
							<span>
								<i class="fa-light fa-pen"></i>
							</span>
							<span>
								{{$t("suggest") | capitalize}}
							</span>
							<span v-if="loadingSuggestions" class="loading">
								<i class="fa-light fa-circle-notch fa-spin"></i>
								<!-- {{$store.state.synonymAmounts}} -->
							</span>
						</span>
					</a>
					<input  ref="synonymFilter" type="text" class="synonym-filter" v-bind:placeholder="$t('search')+'...'" v-model="searchFilter" v-if="globalSynonyms.length > 0"/>  
					<div v-for="(globalSynonym, index ) in filteredSynonymList" :key="index" >
						<a class="menu-item global-synonym ellipsis" @click="onAddGlobalSynonym(globalSynonym, null)">
							{{globalSynonym.name}}
						</a>
					</div>
				</div>
			</div>
				
				<div v-if="templateMethods.length > 0" class="menu-item submenu method" @mouseover="customMethodsContextMenu = true" @mouseleave="customMethodsContextMenu = false">
					<span>
						{{$t('methods.title')}}
					</span> 
					<div  v-if="customMethodsContextMenu" class="custom-context-menu custom-scrollbar-grey-on-grey">	
						<div v-for="(templateMethod, index ) in templateMethods" :key="index">
							<a class="menu-item method" @click="onAddTemplateMethod(templateMethod)">
								{{templateMethod.name}}
							</a>
						</div>
					</div>
				</div>

				<div v-if="selectionLength" class="menu-item submenu" @mouseover="stylingContextMenu = true" @mouseleave="stylingContextMenu = false">
					<span>{{$t('variant-editor.styling-menu')}}</span> 
					<div  v-if="stylingContextMenu" class="custom-context-menu custom-scrollbar-grey-on-grey">	
						<a class="menu-item" @click="setStyling('bold')" :class="{'is-selected-format' : selectedTextFormats.bold == true}"><i class="fa-light fa-bold"></i></a>
						<a class="menu-item" @click="setStyling('italic')" :class="{'is-selected-format' : selectedTextFormats.italic == true}" ><i class="fa-light fa-italic"></i></a>
						<a class="menu-item" @click="setStyling('underline')" :class="{'is-selected-format' : selectedTextFormats.underline == true}"><i class="fa-light fa-underline"></i></a>
						<!-- <a class="menu-item" @click="onAddLink"><i class="fa-light fa-link"></i></a> -->
						<a class="menu-item" @click="onLinkUpdated(selectionText)"><i class="fa-light fa-link"></i></a>
					</div>
				</div>
				<div v-if="selectionLength" class="menu-item submenu" @mouseover="headingContextMenu = true" @mouseleave="headingContextMenu = false">
					<span>{{$t('variant-editor.headings')}}</span> 
					<div  v-if="headingContextMenu" class="custom-context-menu custom-scrollbar-grey-on-grey" >	
						<div v-for="heading in headings" :key="heading">
							<a class="menu-item" @click="setHeader(heading)" :class="{'is-selected-format' : selectedTextFormats.header == heading}">H{{heading}}</a>
						</div>
					</div>	
				</div>
		</context-menu>

		<select-variable-popover
			v-if="variablePopover"
			:left="variablePopover.x"
			:top="variablePopover.y"
			:moveLeft="movePanel"
			:variable-instance="variablePopover.updatingVariable || null"
			@variable-updated="variable => onVariableUpdated(variable)"
			@close="onVariablePopoverClose"
		/>
		<create-synonym-popover 
			v-if="synonymPopover"
			@close="onSynonymPopoverClose"
			:selected-text="selectionText"
			:synonymSuggestions="synonymPopover.synonymSuggestions || null"
			:synonym-instance="synonymPopover.updatingSynonym || null"
			:formatting="synonymPopover.formatting || null"
			:localSynonym="synonymIsLocal"
			@converted-to-global="globalSynonym => handleConversionInVariant(globalSynonym)"
			@synonym-updated="synonym => onSynonymUpdated(synonym)"
			@format-updated="(synonym, format) => onAddGlobalSynonym(synonym, format)"
		/>
		<create-template-method-popover
			v-if="templateMethodPopover"
			@close="onAddTemplateMethodClose"
			:templateMethod="selectedTemplateMethod"
			:method-instance="templateMethodPopover.updatingMethod || null"
			@template-method-updated="method => onTemplateMethodUpdated(method)"
		/>
		<create-link-popover 
			v-if="linkPopover"
			@close="onLinkPopoverClose"
			:selected-text="selectionText"
			:link-instance="linkPopover.updatingLink || null"
			@link-updated="link => onLinkUpdated(link)"
		/>
	</div>
</template>
<script>
import Quill from 'quill'
import Parchment from 'parchment'
import VariableHelpers from '@/assets/js/variableHelpers.js'
import EventBus from '@/assets/js/eventBus.js'
import ContextMenu from '@/components/ContextMenu'
import SelectVariablePopover from '@/components/SelectVariablePopover'
import CreateSynonymPopover from '@/components/CreateSynonymPopover'
import CreateLinkPopover from '@/components/CreateLinkPopover'
import CreateTemplateMethodPopover from '@/components/CreateTemplateMethodPopover'
import orderBy from 'lodash/orderBy'
export default {
    props: {
		variant: { type: String, required: true },
		editing: { type: Boolean, required: true },
		higlightOrEditing: Boolean,
		variantObject: Object,
		draggingVariant: {type: Boolean, default: false}
    },
    data () {
        return {
				editor: null, // reference to the quill editor when initialized
				caretPosition: 0, // this is the cursor location, or the beginning index of a selection
				selectionLength: 0, // the length of a selection, or 0 if no selection.
				hasFocus: false, // whether the editor has focus or not
				contextMenu: null,
				variablePopover: null,
				movePanel: false,
				synonymPopover:null,
				linkPopover: null,
				selectionText: "", // This is the string of the selected text,
				customMethodsContextMenu: false,
				customGlobalSynsContextMenu: false,
				stylingContextMenu: false,
				headingContextMenu: false,
				templateMethodPopover:false,
				selectedTemplateMethod: null,
				selectedTextFormats: null,
				headings: ['1','2','3','4','5'],
				editorIsDisabled: null,
				synonymIsLocal: false,
				searchFilter: '',
				previousHighlight: {
					selectionLength: null,
					caretPosition: null,
					selectionText:null
				},
				supportedTags: ["img","span","p","a", "li", "ul", "ol", "blockquote", "table", "tr", "th", "td", "caption", "colgroup", "col", "thead", "tbody", "tfoot", "sub", "small", "sup", "mark", "del", "ins", "strong", "strike", "big" ],
				aiSuggestions: null,
				loadingSuggestions: false
			
        }
    },
    computed: {
		templateMethods () {
			return this.$store.state.template.methods
		},
		globalSynonyms () {
			return this.$store.state.template.globalSynonyms
		},
		methodNames(){
			let names = []
			this.templateMethods.map(m => names.push(m.name))
			return names
		},
		contextMenuSize(){
			return 24 * this.templateMethods.length - 64
		},
		delta(){
			return this.editor.editor.delta
		},
		filteredSynonymList() {
			return orderBy(this.globalSynonyms.filter(syn => syn.name.toLowerCase().includes(this.searchFilter.toLowerCase())), [syn => syn.name.toLowerCase()] ,["asc"])
		},
		compSelected(){
			return  this.editor.getSelection()
		}
	},
    methods: {
			// initializes the quill editor with contents extracted from the variant text.
			initialize () {
				// setup quill editor with relevant keyboard bindings
				let that = this
				let bindings = {
					enter: {
						key: 13,
						handler () {
							that.$store.state.userDevice != "desktop" ? editor.blur() : that.$emit('add-below')
						}
					},
					backspace: {
						key: 8,
						handler () {
							if (that.variant.trim().length == 0) that.$emit('remove', { keepEditing: true })
							else return true
						}
					},
				}
				let editor = this.editor = new Quill(this.$refs.variantEditor, {
					debug: 'error',
					placeholder: this.$t('variant-editor.editor-ph'),
					formats: ['variable', 'synonym','method', 'underline', 'italic', 'bold', 'header', 'globalSynonym', 'background'], 
					modules: {
						keyboard: {
							bindings
						},
					},
				})
				
				editor.clipboard.addMatcher('br', function(node, delta) {
					var Delta = Quill.import('delta')
					// console.log(node)
					// console.log(delta)
					// return delta.compose(new Delta().insert('\n', { bold: false }));
					return delta.compose(new Delta().retain(delta.length(), { bold: false }));
				});
				// editor.clipboard.addMatcher('a', function(node, delta) {
				// 	var Delta = Quill.import('delta')
				// 	const link = {
				// 		href: node.attributes.href.value || null,
				// 		target: node.attributes.target ? node.attributes.target.value : null 
				// 	}	
				// 	return delta.compose(new Delta().retain(delta.length(), {link: link}));
				// });
				// listen for quill events
				editor.on('selection-change', (range, oldRange, source) => {
					this.onSelectionChanged()
					// const top = document.getSelection().getRangeAt(0).getBoundingClientRect().top
					// console.log(document.getSelection())
					// const left = document.getSelection().getRangeAt(0 + (Math.ceil(range.length) / 2)).getBoundingClientRect().left
					// console.log(top, left)
				})
				// text change
				editor.on('text-change', (delta, oldDelta, source) => {
					this.onSelectionChanged()
					this.contextMenu = null;
					
					
					// Trying to fix the issue where normal text gets background color of a variable or synonym or other format.

					// delta.ops.forEach(operation => {
					// 	if(operation.attributes && Object.keys(operation.attributes).length == 1 && operation.attributes.background){
					// 		console.log(operation)
					// 		this.removeBackgroundFormat(delta.ops[0].retain);
					// 	} 
					// })
	
					if (source !== Quill.sources.USER) return // if the change is not caused by the user, return. This happens e.g. when initializing the editor with variant text.
					else this.$emit('variant-updated', this.extractVariant())
				})
			
				// blur
					editor.root.addEventListener('blur', event => {
					if (this.variablePopover) {
						// // do not allow blur when adding a variable. Keep the cursor and selection as well.
						// this.editor.setSelection(this.editor.getSelection())
						EventBus.$off('variableClicked')
					}	
					if (this.synonymPopover) {
						// // do not allow blur when adding a Synonym. Keep the cursor and selection as well.
						// this.editor.setSelection(this.editor.getSelection())
						EventBus.$off('synonymClicked')
						EventBus.$off('globalSynonymClicked')
					}
					if (this.templateMethodPopover) {
						// // do not allow blur when adding a template method. Keep the cursor and selection as well.
						// this.editor.setSelection(this.editor.getSelection())
						EventBus.$off('methodClicked')
					}
					if (this.linkPopover) {
						// // do not allow blur when adding a link. Keep the cursor and selection as well.
						// this.editor.setSelection(this.editor.getSelection())
						EventBus.$off('linkClicked')
					}
					if(this.customGlobalSynsContextMenu == true){
						// Do not allow blur when the synonym submenu is open. then the use can use the search function
					}
					else {
						this.$emit('blur')
						EventBus.$off('methodClicked')
						EventBus.$off('synonymClicked')
						EventBus.$off('globalSynonymClicked')
						EventBus.$off('variableClicked')
						EventBus.$off('linkClicked')
						// this.variablePopover = null

					setTimeout(() => {													
						this.contextMenu = null
					}, 200)
				}
	
				})

				// focus
				editor.root.addEventListener('focus', event => {
					this.$emit('focus')
					EventBus.$on('variableClicked', this.onVariableClicked)
					EventBus.$on('synonymClicked', this.onSynonymClicked)
					EventBus.$on('globalSynonymClicked', this.onGlobalSynonymClicked)
					EventBus.$on('methodClicked', this.onMethodClicked)
					EventBus.$on('linkClicked', this.onLinkClicked)
				})

				if(this.$store.state.userDevice != "desktop"){
					editor.root.addEventListener('touchend', e => {	
						this.setFocus(true)
						const x = e.pageX
						const y = e.pageY
						this.contextMenu = { x, y }
					})
				} else {
					editor.root.addEventListener('click', e => {
						var rect = document.getSelection().getRangeAt(0).getBoundingClientRect();
						var x = rect.left + (rect.width / 2)
						var y = rect.top + rect.height
						this.contextMenu = { x, y }
	
	
						// "+ variable" opens where mouse is if variant is empty
						if(this.contextMenu.x == 0 && this.contextMenu.y == 0){
							this.contextMenu.x = event.clientX
							this.contextMenu.y = event.clientY
						}
					})
				}

			
				
				editor.root.addEventListener('contextmenu', e => {
						e.preventDefault()
						var rect = document.getSelection().getRangeAt(0).getBoundingClientRect();
						var x = rect.left + (rect.width / 2)
						var y = rect.top + rect.height
						this.contextMenu = { x, y }

				})
				// set the contents
				let contentsToSet = this.getStylingContentsFromVariant(this.variant)
				this.editor.setContents(this.getQuillContentsFromVariant(contentsToSet))

				if(this.$store.state.showingTemplateBackupInPreview){
					// Disable editor if showing a backup version of the template
					this.editorIsDisabled = true
					this.editor.enable(false);
				}
			},
			setFocus(focus) {
				// setTimeout(() => {
					// this.hasFocus = focus
					if (focus && this.editor) { 
						this.editor.root.focus()
					}
				// }, 0)
			},
			blurEditor(blur){
				if(blur && this.editor){
					this.editor.root.blur()	
				}
			},
			// extracts the variant text from the quill contents
			extractVariant () {
				let isHeading;
				let variant = this.editor.getContents().ops.map(operation => {
					if( operation.attributes && operation.attributes.header){
						isHeading = operation.attributes.header
					}
					if (operation.insert.variable) { // is a variable
						if(operation.insert.variable.formatting){return this.extractStylesForOperation(operation, VariableHelpers.insertFormatting(operation.insert.variable.name, operation.insert.variable.formatting) )}
						else{return this.extractStylesForOperation(operation, operation.insert.variable.name)}
					} else if (operation.insert.synonym) { // is a synonym
						return this.extractStylesForOperation(operation, ':syn(' + operation.insert.synonym.values + ')')
					} else if(operation.insert.globalSynonym){ //is a global synonym
							if(operation.insert.globalSynonym.formatting == null || ''){
								return this.extractStylesForOperation(operation, ':gsyn(' + operation.insert.globalSynonym.synonym + ')')
							} else return this.extractStylesForOperation(operation, ':gsyn(' + operation.insert.globalSynonym.synonym + '|' + operation.insert.globalSynonym.formatting + ')')
					} else if (operation.insert.method){ // is a method	
					return	this.extractStylesForOperation(operation, operation.insert.method.values)
					} else {
						if(operation.attributes){
							return this.extractStylesForOperation(operation)
						}else{
							return isHeading ? operation.insert : operation.insert.replaceAll(/(?:\r\n|\r|\n)/g, '<br>')
						} // plain text
					}
				}).join('')
				if(variant.match(/<a[^>]*>/ig)){ //Removing all html tags inside a <a href="X"> - to prevent errors in the link href text
					variant.match(/<a[^>]*>/ig).forEach(match => {
							if(match.substr(1, match.length).includes('<')){
								// match contains extra tags and we should remove them
								let anchorTag = variant
								let first = anchorTag.indexOf(match) 
								anchorTag = anchorTag.substr(first, variant.length)		
								let tag = 0
								let stopCounting = false
								//start counting opening tags at first occurence of <a
								const process = (character, index) => {
									if(character == '<') tag++
									if(character == '>') tag--
									if(index > 0 && tag == 0 && stopCounting == false){
										stopCounting = true
										anchorTag = anchorTag.substr(0, index + 1)
									}
								};
								[...anchorTag].forEach(process)
								
								//Moving the tags inside the a tag out before the tag.
								let tagsInside = anchorTag.substr(1, anchorTag.length).match(/<[^>]*>/gi)
								let tagToRemove = tagsInside[0].replaceAll(/<|\/|>/g,'')
								let strippedAnchortag = anchorTag.substr(1, anchorTag.length).replaceAll(/<[^>]*>/gi, '')
								variant = variant.replace(anchorTag, tagsInside.join('')+'<'+strippedAnchortag)
								// variant = variant.replaceAll(/<[^>]*><\/[^>]*>/gi, '')
								let re = new RegExp(`<${tagToRemove}></${tagToRemove}>`, 'gi')
								variant = variant.replaceAll(re, '')

							}
						// Match does not contain any extra tags so please continue
					})	
				}
				// quill always adds a newline at the end. Let's remove that and return the string.
				//Now all newlines are replaced with breaks. we need to remove that one instead.
				return isHeading ? `<h${isHeading}> ${ variant.replaceAll('\n', '') } </h${isHeading}>` : variant.substr(0, variant.length-4)
			},
			extractStylesForOperation(operation, extractedValue){
				let styledOp = extractedValue ? extractedValue : operation.insert
				if(operation.attributes.underline == true){styledOp = '<u>' + styledOp + '</u>'}
				if(operation.attributes.italic == true){styledOp = '<em>' + styledOp + '</em>'}
				if(operation.attributes.bold == true){styledOp = '<b>' + styledOp + '</b>'}
							// This is only if the linkbuilder is formatting when loading quill
							// if(operation.attributes.link){
							// 	if(operation.attributes.link.href) styledOp = `<a target="${operation.attributes.link.target}" href="${operation.attributes.link.href}">` + styledOp + '</a>'
							// 	else styledOp = `<a href="${operation.attributes.link.href}">` + styledOp + '</a>'
							// 	} 
				return styledOp
			},
			getStylingContentsFromVariant(text){ //First step in setting quill content for the editor. Get the styling elements by converting html tags into the delta format for quill.
				let contents= []
				// if(text.match(/<\s*\/?br\s*\/?>/g)){
				// 		console.log("one match")
				// 		// <br\s*\/?>|<\s*\/?br>
				// 		// console.log(text.match(/<br\s*\/?>/g))
				// 		// We should convert all wrong break tags to the ones quill understand
				// 	}					
					text = text.replaceAll(/<\s*\/?br\s*\/?>/g, '<br>')
					// let patternToIgnore = /:syn\(.*?\)|<a[^>]*>([^<]+)<\/a>|<ol\s*\/?>|<ul\s*\/?>|<li\s*\/?>|<.ol.+?>|<.ul.+?>|<.li.+?>/ig;
					// let patternToIgnore = /<\s*a[^>]*>(.*?)<\s*\/\s*a>|<ol\s*\/?>|<ul\s*\/?>|<li\s*\/?>|<.ol.+?>|<.ul.+?>|<.li.+?>/ig;
					
					// let patternToIgnore = /<ol\s*\/?>|<ul\s*\/?>|<li\s*\/?>|<blockquote\s*\/?>|<.ol.+?>|<.ul.+?>|<.li.+?>|<.blockquote.+?>|<a[^>]*>([^<]+)<\/a>/ig;
					//Above is old working pattern which turned out not to work. below is the working pattern to ignore theese tags
					
					let regexTags = []
					this.supportedTags.forEach((tag) => {
						regexTags.push(`<${tag}\\b[^>]*>|</${tag}>`)
					})
					let patternToIgnore = new RegExp(regexTags.join("|"), "gi")
					// let patternToIgnore = /<td\b[^>]*>|<\/td>|<th\b[^>]*>|<\/th>|<tr\b[^>]*>|<\/tr>|<table\b[^>]*>|<\/table>|<blockquote\b[^>]*>|<\/blockquote>|<ol\b[^>]*>|<\/ol>|<ul\b[^>]*>|<\/ul>|<li\b[^>]*>|<\/li>|<a[^>]*>|<\/a>/ig;
					if(text.match(patternToIgnore)){
						let contentToIgnore = []
						const tagsToIgnore = text.match(patternToIgnore)
						let alternateReg = new RegExp(tagsToIgnore.join('|'), 'g')
						// const surroundingTxt = text.split(alternateReg)
						console.log(alternateReg)
						const surroundingTxt = text.split(patternToIgnore)
						console.log(surroundingTxt)
						surroundingTxt.forEach((text, index) => {
							if(text){contentToIgnore.push(text)}
							if(tagsToIgnore && tagsToIgnore[index]){
								let currentSyn = tagsToIgnore[index]
								tagsToIgnore[index] = tagsToIgnore[index].replaceAll('<', '[<]')
								tagsToIgnore[index] = tagsToIgnore[index].replaceAll('>', '[>]')
								contentToIgnore.push(tagsToIgnore[index])
							}
						})
						text = contentToIgnore.join('')
					}						
				if(text){
					// if(text.match(/(<([^>|a|ul|ol|li]+)>)/ig)){
					// This helps quill to not remove the spaces in the text when it converts from html to delta -- maybe find a better way?
					// text = text.replaceAll(' ', '^^') //the 'old' way. 
					
					
					// This works when you want to format standard a tags to quill links. (doesnt work when you want to use vars and syns inside <a> tags)
					// if(text.match(/<\s*a[^>]*>(.*?)<\s*\/\s*a>/ig)){  // now firstly let quill match all <a> tags and convert them to delta format. then do the 'space' fix on all other text
					// 	let treatedContents = []
					// 	let textWithoutLinkTags = []
					// 	let linkTags = text.match(/<\s*a[^>]*>(.*?)<\s*\/\s*a>/ig)
					// 	let linkTagPattern = new RegExp(linkTags.join('|'), 'g')
					// 	text.split(linkTagPattern).forEach(t => {
					// 		textWithoutLinkTags.push(t.replaceAll(' ', '^^'))
					// 	})

					// 	textWithoutLinkTags.forEach((text, index) => { 
					// 		if(text) treatedContents.push(text)
					// 		if(linkTags && linkTags[index]) treatedContents.push(linkTags[index])
					// 	})
					// 	text = treatedContents.join('')	
					// }

					const converted = this.editor.clipboard.convert(text)
					converted.ops.forEach(op =>{
						op.insert =  op.insert.replaceAll('^^', ' ')
						op.insert =  op.insert.replaceAll('[<]', '<')
						op.insert =  op.insert.replaceAll('[>]', '>')
						contents.push(op)
					})
				} else contents.push({insert: text})
	
				return contents
			},
			getQuillContentsFromVariant(variant){
				let varOrSynOrMethodPresent;
				let pattern;
				if(this.methodNames.length > 0){
					let methodsRegex = [] 
					this.methodNames.forEach(m => {
						//this regex makes sure that you can have () inside a method.
						let singleMethodRegex = ":" + m + "\\((?:[^)(]+|\\((?:[^)(]+|\\([^)(]*\\))*\\))*\\)";
						methodsRegex.push(singleMethodRegex)
					})
					pattern = new RegExp('(?:{.*?\\})|:syn\\((?:[^)(]+|\\((?:[^)(]+|\\([^)(]*\\))*\\))*\\)|:gsyn\\((?:[^)(]+|\\((?:[^)(]+|\\([^)(]*\\))*\\))*\\)'+ '|' + methodsRegex.join('|')  , 'g')
				} else{ pattern = /(?:{.*?\})|:syn\((?:[^)(]+|\((?:[^)(]+|\([^)(]*\))*\))*\)|:gsyn\((?:[^)(]+|\((?:[^)(]+|\([^)(]*\))*\))*\)/g}
				let contents = []
				variant.forEach(v => {
					if(v.insert){
						let varsAndSynonymsAndMethods = v.insert.match(pattern)
						// console.log("Vars, Syns and Methods:",varsAndSynonymsAndMethods)
						let variantWithoutVarsAndSynonyms = v.insert.split(pattern)
						// console.log("Cleaned text:",variantWithoutVarsAndSynonyms)
						variantWithoutVarsAndSynonyms.forEach((text, index) => {
							if(text){
								//all below was the wrong way of creating <a> tags. its now moved into the the quill.addmatcher()

								// if(text.match(/<a(.*?)>(.*?)<\/a>/g)){
								// 	let alternateReg = new RegExp(text.match(/<a(.*?)>(.*?)<\/a>/g).join('|'), 'g')
								// 	let matches = text.match(alternateReg)
								// 	let otherText = text.split(alternateReg)
								// 	// console.log(matches)
								// 	// console.log(otherText)
								// 	var stringToHTML = function (str) { //this is in order to parse <a> tags into the quill delta format
								// 		var parser = new DOMParser();
								// 		var doc = parser.parseFromString(str, 'text/html');
								// 		console.log(doc.body)
								// 		return doc.body.childNodes;
								// 	};
								// 	otherText.forEach((text, index) =>{
								// 		if(text){
								// 			contents.push({insert: text ,attributes: v.attributes})
								// 		}
								// 		if(matches && matches[index]){
											
								// 			let result = stringToHTML(matches[index])
								// 			// console.log(result[0].childNodes)
								// 			const attributes = {
								// 				link: {
								// 					href : result[0].attributes.href.value,
								// 					target : result[0].attributes.target ? result[0].attributes.target.value : null
								// 				}
								// 			}
								// 		contents.push({insert: result[0].childNodes[0].outerHTML ? result[0].childNodes[0].outerHTML : result[0].innerText, attributes: attributes})
								// 		}
								// 	})
								// } else contents.push({insert: text, attributes: v.attributes})
								contents.push({insert: text, attributes: v.attributes})
							}
							if(varsAndSynonymsAndMethods && varsAndSynonymsAndMethods[index]){
								varOrSynOrMethodPresent = true
								const attributes = v.attributes
								const varOrSynOrMethod = varsAndSynonymsAndMethods[index]
								if(varsAndSynonymsAndMethods[index].startsWith("{")){
									contents.push({delete: varsAndSynonymsAndMethods[index].length})
									let variable = VariableHelpers.getByName(varsAndSynonymsAndMethods[index], this.$store.getters.combinedVariables)
									if (!variable) {
										console.log('TEMPLATE ERROR: Missing variable:', varsAndSynonymsAndMethods[index])
										contents.push({insert: {variable: {formatting: '', displayName: this.$t('variant-editor.unknown-variable'), name: varsAndSynonymsAndMethods[index]}}, attributes})
									} else {
										contents.push({insert: {variable: {formatting: VariableHelpers.getFormatting(varsAndSynonymsAndMethods[index]), ...variable}}, attributes })
									}
								}	// else if is synonym
								else if(varsAndSynonymsAndMethods[index].startsWith(":syn")){
									let synonym = varsAndSynonymsAndMethods[index]
									if (!synonym) {
										console.log('TEMPLATE ERROR: Missing synonym:', varOrSynOrMethod)
									} else {
										contents.push({insert: {synonym: {values: varsAndSynonymsAndMethods[index].substr(5).slice(0, -1)}}, attributes})
									}
								}
								else if(varsAndSynonymsAndMethods[index].startsWith(":gsyn")){
									let globalSynonym = varsAndSynonymsAndMethods[index]
									if (!globalSynonym) {
										console.log('TEMPLATE ERROR: Missing synonym:', varOrSynOrMethod)
									} else {
										const gsyn = varsAndSynonymsAndMethods[index].substr(6).slice(0, -1).split('|')
										contents.push({insert: {globalSynonym: {synonym: gsyn[0], formatting: gsyn[1]}}, attributes})
									}
								}
								//else is a method
								else{
									let method = varsAndSynonymsAndMethods[index]
									if (!method) {
										console.log('TEMPLATE ERROR: Missing method!:', varOrSynOrMethod)
									} else {						
										contents.push({insert: {method: {values: varsAndSynonymsAndMethods[index]}}, attributes})
									}
								}
							}
						})
					}
				})		
			

				// If vars or syns are present in contents then it changes the newline behavior. this prevents unexpected newlines in the end of a variant.
				if(contents.length > 2 && varOrSynOrMethodPresent == true  && contents[contents.length-1].insert === "\n\n") {
					console.log("double newlines")
					contents.push({insert: '\n\n'})
				} 
				else if(contents.length > 2 && varOrSynOrMethodPresent == true  && contents[contents.length-1].insert === "\n") {
					console.log("single newline")
					contents.push({insert: '\n\n'})
				}
				if(contents.length > 1 && !varOrSynOrMethodPresent && contents[contents.length-1].insert === "\n\n") {
					console.log("double newlines no varsorsyns")
					contents.push({insert: '\n'})
				} 
				else if(contents.length > 1 && !varOrSynOrMethodPresent && contents[contents.length-1].insert === "\n") {
					console.log("single newline no varsorsyns")
					contents.push({insert: '\n'})
				}
				// contents.push({insert: '\n'})
				// console.log(contents)
				return contents
			},

			onSelectionChanged() {
				let range = this.editor.getSelection()
				if (range) {
					this.caretPosition = range.index
					this.selectionLength = range.length	
					// console.log('selection changed', range)
					this.getSelectionAsString()

					if (range.length) {
						var rect = document.getSelection().getRangeAt(0).getBoundingClientRect();
						var x = rect.left + (rect.width / 2)
						var y = rect.top + rect.height
						this.contextMenu = { x, y }
					} else this.contextMenu = null
				}	
			},
			getSelectionAsString(){
				let selection = this.editor.getSelection()
				let selectedContent = this.editor.getContents(selection.index, selection.length)
				if(selectedContent.ops.length){
				let selectedText = selectedContent.ops.find(s => s.insert)
				this.selectionText = selectedText.insert
				}
				else this.selectionText = ""
				
			},
			onAddTemplateMethod(method){
				this.templateMethodPopover = { x: this.contextMenu.x - 23, y: this.contextMenu.y}
				this.selectedTemplateMethod = method
				this.contextMenu = null
			},
			onAddTemplateMethodClose () {
				this.templateMethodPopover = null
				this.selectedTemplateMethod = null
				// this.setFocus(true)
			},
			onAddSynonym(aiSuggestions){
				this.aiSuggestions = null
				this.synonymIsLocal = true

				if(aiSuggestions){

					this.synonymPopover = { x: this.contextMenu.x - 23, y: this.contextMenu.y, updatingSynonym: null, synonymSuggestions: true}
					this.contextMenu = null
				} else {
					this.synonymPopover = { x: this.contextMenu.x - 23, y: this.contextMenu.y}
					this.contextMenu = null
				}


			},
			onSynonymPopoverClose () {
				this.synonymPopover = null
				this.aiSuggestions = null
				// this.setFocus(true)
			},
			onSynonymUpdated (synonym) {
				if (this.selectionLength > 0) {
					if (this.synonymPopover.updatingSynonym) this.editor.deleteText(this.caretPosition, 1) // a synonym blot has the length of 1 
					else this.editor.deleteText(this.caretPosition, this.selectionLength)
				}
				
				this.editor.insertEmbed(this.caretPosition, 'synonym', {
					values: synonym
				}, Quill.sources.USER)
				
				this.editor.insertText(this.caretPosition + 1, ' ')

				// set selection to just after new/updated synonym
				this.$nextTick(() => this.editor.setSelection({ index: this.caretPosition + 2, length: 0 }))
				this.synonymPopover = null
			},
			onSynonymClicked ({ node, synonym, event }) {
				if( this.$store.state.variantBeingEdited.id == this.variantObject.id){
					this.caretPosition = Parchment.find(node).offset(this.editor.scroll)
					this.selectionLength = 1
					this.synonymIsLocal = true
					this.synonymPopover = { x: event.clientX - 23, y: event.clientY + 10, updatingSynonym: synonym }
					setTimeout(() => this.contextMenu = null)
				}
			},
			onAddGlobalSynonym(synonym, format){
				this.searchFilter = ''
				if (this.selectionLength > 0) this.editor.deleteText(this.caretPosition, this.selectionLength)
				
				this.editor.insertEmbed(this.caretPosition, 'globalSynonym', {
					synonym: synonym.name,
					formatting: format || ''
				}, Quill.sources.USER)
				this.editor.insertText(this.caretPosition + 1, ' ') //Testing if it makes sense - if a variable is inserted without a marked/selected text, then add a space after.

				// set selection to just after new/updated global syn
				this.$nextTick(() => this.editor.setSelection({ index: this.caretPosition + 2, length: 0 }))
				this.variablePopover = null
				this.caretPosition = this.caretPosition + 1	
			},
			onGlobalSynonymClicked({ node, synonym, event, id }){
				if( this.$store.state.variantBeingEdited.id == this.variantObject.id){ // Avoid opening a popover for every editor that is open if the user has unscoped view on
					const synValues = this.globalSynonyms.find((syn => syn.name == synonym.synonym))
					this.caretPosition = Parchment.find(node).offset(this.editor.scroll)
					this.selectionLength = 1
					// console.log(synonym, this.variant)
					this.synonymPopover = { x: event.clientX - 23, y: event.clientY + 10, updatingSynonym: synValues, formatting: synonym.formatting }
					setTimeout(() => this.contextMenu = null)
				}
			},
			onGlobalSynonymFormatUpdated(format){

			},
			handleConversionInVariant(globalSynonym){
				this.synonymIsLocal = false
				this.editor.deleteText(this.caretPosition, 1)
				this.editor.insertEmbed(this.caretPosition, 'globalSynonym', {
					synonym: globalSynonym.name
				}, Quill.sources.USER)
				this.editor.insertText(this.caretPosition + 1, this.selectionText ? '' : ' ') 
				console.log(globalSynonym)
				this.onSynonymPopoverClose()
			},
			onAddVariable () {
				this.variablePopover = { x: this.contextMenu.x - 23, y: this.contextMenu.y }
				this.contextMenu = null
			},
			onVariableClicked ({ node, variable, event }) {
				if( this.$store.state.variantBeingEdited.id == this.variantObject.id){
					this.caretPosition = Parchment.find(node).offset(this.editor.scroll)
					this.selectionLength = 1
					// if (window.innerWidth - event.clientX < 500) {
					// 	x = window.innerWidth - 550
					// }
					console.log(variable)
					this.variablePopover = { x: event.clientX - 23, y: event.clientY + 10, updatingVariable: variable }
					setTimeout(() => this.contextMenu = null)
				}
			},
			onVariableUpdated (chosenVariable) {
				if (this.selectionLength > 0) {
					if (this.variablePopover.updatingVariable) this.editor.deleteText(this.caretPosition, 1) // a variable blot has the length of 1 
					else this.editor.deleteText(this.caretPosition, this.selectionLength)
				}
				this.editor.insertEmbed(this.caretPosition, 'variable', {
					name: chosenVariable.name,
					formatting: chosenVariable.format,
				}, Quill.sources.USER)
			
				this.editor.insertText(this.caretPosition + 1, this.selectionText ? '' : ' ') //Testing if it makes sense - if a variable is inserted without a marked/selected text, then add a space after.

				// set selection to just after new/updated variable
				this.$nextTick(() => this.editor.setSelection({ index: this.caretPosition + 2, length: 0 }))
				this.variablePopover = null
			},
			onVariablePopoverClose () {
				this.variablePopover = null
				// this.setFocus(true)
			},
			enableMoveLeft(){
				this.movePanel = true
				//Runs twice for some reason?
			},
			disableMoveLeft(){
				this.movePanel = false
				//Runs twice for some reason?
			},
			onTemplateMethodUpdated(method){
				if (this.selectionLength > 0) {
					if (this.templateMethodPopover.updatingMethod) this.editor.deleteText(this.caretPosition, 1) // a method blot has the length of 1 
					else this.editor.deleteText(this.caretPosition, this.selectionLength)
				}
				console.log(method)
				this.templateMethodPopover = null
				this.editor.insertEmbed(this.caretPosition, 'method', {
					values: method
				}, Quill.sources.USER)			
				this.editor.insertText(this.caretPosition + 1, this.selectionText ? '' : ' ')
			},
			onMethodClicked ({ node, method, event }) {
				if( this.$store.state.variantBeingEdited.id == this.variantObject.id){
					this.caretPosition = Parchment.find(node).offset(this.editor.scroll)
					this.selectionLength = 1
					this.selectedTemplateMethod = this.templateMethods.find(tm => tm.name == method.values.substr(1, method.values.indexOf('(') -1 ))
					this.templateMethodPopover = { x: event.clientX - 23, y: event.clientY + 10, updatingMethod: method}
					setTimeout(() => this.contextMenu = null)
				}
			},
			setStyling(style){
				let currentFormats = Object.keys(this.editor.getFormat(this.caretPosition, this.selectionLength)).includes(style)
				this.editor.formatText(this.caretPosition, this.selectionLength, style, currentFormats ? false : true, Quill.sources.USER);
				// this.editor.formatText(this.caretPosition, this.selectionLength, style, true, Quill.sources.USER);
				if(this.caretPosition == 0 && this.selectionLength == this.variant.length) this.editor.insertText(this.caretPosition + this.selectionLength,  ' ')
				this.stylingContextMenu = false
			},
			setHeader(style){
				let currentFormats = this.editor.getFormat(this.caretPosition, this.selectionLength)
				if(currentFormats && currentFormats.header == style) this.editor.formatLine(0, this.variant.length, 'header', false,  Quill.sources.USER);
				else this.editor.format('header', style, Quill.sources.USER);
			},
			onAddLink(){
				this.linkPopover = { x: this.contextMenu.x - 23, y: this.contextMenu.y} // used for the linkbuilder
		
			},
			onLinkPopoverClose () {
				this.linkPopover = null
			},
			onLinkUpdated (link) {
				// if(this.linkPopover.updatingLink) this.editor.removeFormat(this.caretPosition, this.selectionLength);	//with the linkbuilder popover
				// this.editor.format('link', link, Quill.sources.USER);
				// this.editor.formatText(this.caretPosition, this.selectionLength,'link', {href: link.href, target : link.target}, Quill.sources.USER); //with the linkbuilder popover
				console.log(link)
				this.editor.insertText(this.caretPosition + this.selectionLength, '</a>')
				this.editor.insertText(this.caretPosition, '<a href="">')
				this.$nextTick(() => this.editor.setSelection(this.caretPosition + 9)) 
			},
			onLinkClicked ({ node, link, event }) {
				if( this.$store.state.variantBeingEdited.id == this.variantObject.id){
					this.selectionText = node.innerText
					this.selectionLength = node.innerText.length
					this.caretPosition = Parchment.find(node).offset(this.editor.scroll)
					this.linkPopover = { x: event.clientX - 23, y: event.clientY + 10, updatingLink: link}
					setTimeout(() => this.contextMenu = null)
				}
			},
			getFormatFromSelection(){
				if(this.editor.getFormat(this.caretPosition, this.selectionLength)) this.selectedTextFormats = this.editor.getFormat(this.caretPosition, this.selectionLength)
				else this.selectedTextFormats = null
			},
			
			textHighlight(){
				if (this.selectionLength > 0) {
					if( this.previousHighlight.selectionLength){
						this.editor.formatText(this.previousHighlight.caretPosition, this.previousHighlight.selectionLength, 'background', 'transparent');
					}
					this.editor.formatText(this.caretPosition, this.selectionLength, 'background', 'var(--orange-web)');
					this.previousHighlight.selectionText = this.selectionText
					this.previousHighlight.selectionLength = this.selectionLength
					this.previousHighlight.caretPosition = this.caretPosition
				} 
				else if( this.previousHighlight.selectionLength){
					this.editor.formatText(this.previousHighlight.caretPosition, this.previousHighlight.selectionLength, 'background', 'transparent');
				}
			}
		},
		watch: {

			'editing': {
				immdiate: true, 
				handler (editing) {
					if (editing) { 
							this.setFocus(true)
					} else {
							this.blurEditor(true)
							// this.$emit('blur')
					}
				}
			},
			'caretPosition': {
				immdiate: true, 
				handler (val) {
					this.getFormatFromSelection()
					// this.textHighlight()
				}
			},
			'selectionLength': {
				immdiate: true, 
				handler (val) {
					this.getFormatFromSelection()
					// this.textHighlight()
				}
			},
			'synonymPopover': {
				handler: function(){
					if(this.synonymPopover == null) this.synonymIsLocal = false
				}
			},
			'customGlobalSynsContextMenu': {
				handler: function(){
					if(this.customGlobalSynsContextMenu == true){
						this.$nextTick(() =>{
							this.$refs.synonymFilter.style.minWidth = this.$refs.synonymFilter.clientWidth+'px'
						})
					}
				}
			},
			'draggingVariant': {
				handler: function (){
					if(this.draggingVariant == true) this.contextMenu = null
				}
			},
		},
		mounted () {
			this.initialize()
			EventBus.$on('move_var_popover_back',this.disableMoveLeft)
			EventBus.$on('move_var_popover_left', this.enableMoveLeft)
			EventBus.$on('update-variant-view', () => {
				setTimeout(() => {
					let contentsToSet = this.getStylingContentsFromVariant(this.variant)
					this.editor.setContents(this.getQuillContentsFromVariant(contentsToSet))
				}, 10);
			})
		},
		destroyed(){
			EventBus.$off('update-variant-view')
			EventBus.$off('pasteEvent')	
			EventBus.$off('move_var_popover_back',this.disableMoveLeft)
			EventBus.$off('move_var_popover_left', this.enableMoveLeft)
		},
		components: {
			ContextMenu,
			SelectVariablePopover,
			CreateSynonymPopover,
			CreateTemplateMethodPopover,
			CreateLinkPopover
		}
}
</script>

<style lang="less">
.editorIsDisabled{
	a{
		pointer-events: none;
	}
}
.variant-editor {
	position: relative;
	.ql-container {	
		font-family: 'Roboto', sans-serif;
		font-size: 14px;
		.ql-editor {
			position: relative;
			line-height: 24px;
			padding: 0 !important;

			&.ql-blank::before {
				left: 0;
				width: 100%;
			}
	
			span.variable-blot, span.synonym-blot, span.method-blot, span.global-synonym-blot {
				border-radius: 3px;
				padding: 3px 1px;
				cursor: pointer;
			}
			span.variable-blot{
				background-color: rgba(235, 95, 52, 0.623);
				&:hover{
					background-color: var(--flame);
				}
			}
			span.method-blot{
					background-color: rgba(144, 238, 144, 0.466);
				&:hover{
					background-color: lightgreen;
				}
			}
			span.synonym-blot{
				background-color: rgba(173, 216, 230, 0.555);
				&:hover{
					background-color: rgb(171, 223, 240);
				}
			}
		
			span.global-synonym-blot{
	
				background-color: rgba(173, 216, 230, 0.555);
				&:hover{
					background-color: lightblue;
				}				
				svg{
					width: 6px;
					margin-left: 3px;
				}

			
			}
		}
	}

	.is-selected-format{
		background-color: rgb(89, 102, 109);
	}

	.custom-context-menu, .custom-context-menu-descending{
		max-height: 220px;
		overflow: auto;
	}

	svg.fa-globe{
		width: 8px;
	}

	.global-synonym-seperator{
		border-bottom: 1px solid #485258;
	}

	.synonym-filter{
			background-color: transparent;
			min-width: calc(100% - 10px);
			max-width: 300px;
			color: #fff;
			margin: 4px;
			border: none;
			outline: none;
			+ div{
				border-top: 1px solid #485258;
			}
		}
		.global-synonym{
			max-width: 300px;
		}
}	

	.ql-editor p span:not(.synonym-blot,.global-synonym-blot,.variable-blot,.method-blot){
		padding: 4px 0;
	}
	.not-highlighted .ql-editor p span:not(.synonym-blot,.global-synonym-blot,.variable-blot,.method-blot) {
		// padding: 0px 0;
		background: none !important;
	}
	.not-highlighted .ql-container .ql-editor p .variable-blot{
		background: rgba(235, 95, 52, 0.212)  !important;
	}	
	.not-highlighted .ql-container .ql-editor p .synonym-blot, .not-highlighted .ql-container .ql-editor p .global-synonym-blot{
		background: rgba(173, 216, 230, 0.247) !important;
		// background: rgba(66, 245, 200, 0.336) !important;
	}	
	.not-highlighted .ql-container .ql-editor p .method-blot{	
		background-color: rgba(50, 161, 104, 0.205);
	}

</style>
